import { Component, OnInit, EventEmitter, ChangeDetectorRef, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent , MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Observable, of } from 'rxjs';
import { OrderFieldConfig } from 'src/app/core/classes/orderFieldConfig';
import { Option } from 'src/app/core/interfaces/options-dynamicform';
import { BroadcastService } from 'src/app/shared/services/broadcast.service';
import { DynamicFormServiceService } from 'src/app/shared/services/dynamic-form-service.service';
import { Constants } from '../../constants';
import { PropertyName } from 'src/app/core/enumerations/sectionNames';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';
import { OrdersService } from 'src/app/feature/order/Service/order.service';
import { DoctorsDayDetailsDto } from 'src/app/core/classes/doctorsDayDetailsDto';
import { NotificationService } from '../../services/notification-service';
@Component({
    selector: 'app-select-search-box-api',
    templateUrl: './select-search-box-api.component.html',
    standalone: false
})
export class SelectSearchBoxApiComponent implements OnInit {

  field: OrderFieldConfig;
  group: UntypedFormGroup;
  noData: boolean;
  massDropdown = new Observable<Option[]>();
  id1Dropdown: DoctorsDayDetailsDto[];
  sortedOptions: Option[];
  noRecord = 'noRecord';
  isRequired: boolean;
  required = Constants.IS_REQUIRED;
  invalid = 'invalid';
  isLoading = false;
  selectValueChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  selectValueChangeObservable = this.selectValueChange.asObservable();
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;

  constructor(private broadCastService: BroadcastService,
    private dynamicService: DynamicFormServiceService,
    private cdRef: ChangeDetectorRef,
    public broadcastService: BroadcastService,
    private localStorageService: LocalStorageService,
    private orderService: OrdersService,
    private notification: NotificationService) { }

  ngOnInit() {
    this.massDropdown = of(this.sortedOptions = this.field.options);
    this.group.get(this.field.labelCode).setValidators(this.invalidOptionValidator.bind(this));
    this.group.get(this.field.labelCode).valueChanges.subscribe(x => this.noData = false);
    if (this.group.get(this.field.labelCode).value) {
      let defaultValue: any;
      const index = this.sortedOptions.findIndex(x => x.code === this.group.get(this.field.labelCode).value);
      if (index > -1) {
        defaultValue = this.sortedOptions[index];
        this.group.get(this.field.labelCode).setValue(defaultValue.value);
      }
    }

    this.isRequired = this.dynamicService.checkHasRequired(this.field);
    this.broadCastService.subscribe().subscribe(message => {
      if (message.type === Constants.IsSpecimenAdded) {
        if (this.field.isScannable) {
          this.group.get(this.field.labelCode).setValue('');
          this.massDropdown = of(this.sortedOptions = this.field.options);
        }
      } else if (message.type === Constants.SPECIMEN_EDITED) {
        this.massDropdown = of(this.sortedOptions = this.field.options);
      } else if (message.type === Constants.CLOSE_MAT_AUTOCOMPLETE) {
        this.closeMatAutocomplete();
      }
    });

    const template = (this.localStorageService.getItem("Template")) === 'undefined' ? '' : (this.localStorageService.getItem("Template"));
    const isEdit = (this.localStorageService.getItem("isEdit")) === 'undefined' ? '' : (this.localStorageService.getItem("isEdit"));

    const isCreateOrAddOrderForm = (template === '' && isEdit === '');
    const isTestAsTemplateOrderForm = ((template === Constants.TEST_TEMPLATE || template === Constants.DONOR_TEMPLATE) && isEdit === Constants.PARAMETER_TRUE);
    const isDonorAsTemplateOrderForm = (template === Constants.DONOR_TEMPLATE && isEdit === Constants.PARAMETER_TRUE);
    const isEditOrderForm = (template === '' && isEdit === Constants.PARAMETER_TRUE);

    if (isCreateOrAddOrderForm || isTestAsTemplateOrderForm) {
      this.setDefaultValue([Constants.GENDER, PropertyName.STAT]);
    }

    if (isCreateOrAddOrderForm || isTestAsTemplateOrderForm || isEditOrderForm || isDonorAsTemplateOrderForm) {
      this.setDefaultValue([PropertyName.DonorType, PropertyName.SampleType]);
  }

  }

  setDefaultValue(labelCodes: string[]): void {
    if (labelCodes.includes(this.field.labelCode)) {
      const index = this.sortedOptions.findIndex(x => x.code === this.field.defaultValue);
      if (index > -1) {
        const defaultValue = this.sortedOptions[index];
        this.group.get(this.field.labelCode).setValue(defaultValue.value);
      }
    }
  }
  
  getValueAndCode(item, fieldCode) {
    if (fieldCode === PropertyName.SampleSource) {
      return item.value + ' ' + '(' + item.code + ')';
    }
    return item.value;
  }

  selectionOptionChanged(event: MatAutocompleteSelectedEvent) {
    if (event.option && event.option.id !== this.noRecord) {
      this.group.get(this.field.labelCode).setValue(event.option.viewValue);
      if (this.field.labelCode === PropertyName.SINGLE_TEST) { sessionStorage.setItem('sampleSource', event.option.id); }
      const index = this.id1Dropdown.findIndex(x => x.primaryId === event.option.viewValue);
      const optionToBeBroadcasted = this.id1Dropdown[index];
      this.broadcastService.setDoctorDayDetailsDTO(optionToBeBroadcasted);
    }
  }

  clearOnBackSpace(formControlName) {
    this.id1Dropdown = [];
    this.massDropdown = of(this.sortedOptions);
    this.group.get(formControlName).reset();
    this.autocomplete.openPanel();
  }

  invalidOptionValidator(c: UntypedFormControl) {
    if (c.value && this.sortedOptions.length) {
      const word = c.value.toLowerCase().trim();
      let acc: Option[] = [];
      const val = this.sortedOptions.filter(o =>
        Object.keys(o).some(k => (o.value + ' (' + o.code + ')').toLowerCase().includes(word)));
      acc = acc.concat(val).filter((v, i, a) => a.indexOf(v) === i);
      this.noData = acc.length <= 0;
      this.massDropdown = of(acc);
      const index = acc.findIndex(x => word === this.valueToBecompared(x));
      if (this.noData || index === -1) {
        return { invalidAutocompleteObject: true };
      }
      return null;  /* valid option selected */
    }
    return null;
  }

  valueToBecompared(x) {
    const val = this.field.labelCode === PropertyName.SampleSource ?
      x.value.toLowerCase() + ' (' + x.code.toLowerCase() + ')' : x.value.toLowerCase();
    return val;
  }

  closeMatAutocomplete() {
    this.autocomplete.closePanel();
  }


  getDoctorsDayDetails(event: any) {
    const inputValue = (event.target as HTMLInputElement).value;
    if(event.target.value.length > 0){
      this.setManualMaxLengthError();
    }
    if (event.target.value.length >= 3) {
      this.id1Dropdown = [];
      this.isLoading = true;
      this.orderService.getDoctorsDayInfo(this.orderService.selectedOrderingAccount, inputValue).subscribe({
        next: (res) => {
          this.isLoading = false;
          this.id1Dropdown = res;
        },
        error: () => {
          this.notification.warn("Failed to fetch details!");
          this.isLoading = false;
        }
      });
    }
  }

  setManualMaxLengthError() {
    const control =  this.group.get(this.field.labelCode);
    if (control) {
      const value = control.value;
      const maxLength = 40;

      if (value.length > maxLength) {
        control.setErrors({
          maxlength: { requiredLength: maxLength, actualLength: value.length }
        });
      } else {
        control.setErrors(null);
      }
    }
  }

  onTabOrEnterPressed(formControlName) {
    if (this.id1Dropdown?.length === 1) {
      this.group.get(this.field.labelCode).setValue(this.id1Dropdown[0].primaryId);
      const optionToBeBroadcasted = this.id1Dropdown[0];
      this.autocomplete.closePanel();
      this.broadcastService.setDoctorDayDetailsDTO(optionToBeBroadcasted);
    }
  }
}
